import { render, staticRenderFns } from "./DialogCancelOrder.vue?vue&type=template&id=496948c0&scoped=true"
import script from "./DialogCancelOrder.vue?vue&type=script&lang=js"
export * from "./DialogCancelOrder.vue?vue&type=script&lang=js"
import style0 from "./DialogCancelOrder.vue?vue&type=style&index=0&id=496948c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496948c0",
  null
  
)

export default component.exports